import Button from '@material-ui/core/Button';
import history from 'redux/history';
import PropTypes from 'prop-types';
import React from 'react';
import Warning from '@material-ui/icons/Warning';
import { Link } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import styles from './styles.css';
import withRouter from '../../shared/utils/WithRouter';

const ErrorPage = (props) => {
	const historyState =
		typeof props.router.location.state === 'object'
			? Object.entries(props.router.location.state)
			: Object.entries({ text: null });
	return (
		<div align="center" style={{ margin: '8% 5% 5%' }}>
			<h1 className={styles['h1-style']}>We&apos;re sorry, an unexpected error occurred.</h1>
			<br />
			<Warning style={{ height: 100, width: 100, color: '#FFC107' }} />
			<br />
			<div>
				{historyState.map(
					([key, value]) =>
						value ? (
							<p className={styles['p-style']} key={key}>
								{value}
							</p>
						) : null,
				)}
			</div>
			<h3 className={styles['h3-style']}>
				But it&apos;s okay, we logged the issue to our team and we&apos;ll look at it for you!
			</h3>
			<div>
				<Button
					variant="contained"
					component={Link}
					to="/category"
					style={{
						width: 252,
						height: 54,
						margin: 20,
						fontSize: 18,
						color: props.theme.palette.getContrastText(props.theme.palette.secondary.main),
						backgroundColor: props.theme.palette.secondary.main,
					}}
					label="Go to Home Page"
				>
					Go to Home Page
				</Button>
			</div>
		</div>
	);
};

ErrorPage.propTypes = {
	theme: PropTypes.instanceOf(Object).isRequired,
};

// For testing purposes
export { ErrorPage as ErrorPageClass };

export default withRouter(withTheme(ErrorPage));
